import axios from "axios";

const URL_BASE = "https://servicodados.ibge.gov.br/api/v1/localidades";

export default class LocalidadesService{
	static async listarMunicipios() {
		return axios.get(`${URL_BASE}/municipios?orderBy=nome`);
	}
	static async listarEstados() {
		return axios.get(`${URL_BASE}/estados?orderBy=nome`);
	}
}



// WEBPACK FOOTER //
// ./src/service/LocalidadesService.js